import { useFuseSearch } from "@elixir/utils";
import { Popover } from "antd";
import { useMemo, useState } from "react";
import { DoctorFilterStripUi, TooltipComponent } from "ui";
import { BarsRegularIcon } from "@elixir/icons";
import { Appointment, BasicDoctorInfo } from "@elixir/types";
import useAllQueuesQuery from "../../../apis/tryst/get-all-queues";
import useQueueStore from "../../../stores/queue-store";
import { DoctorSearch } from "./doctor-search";
import useGetQueueConfig from "../../../apis/tryst/get-queue-config";

const DoctorsList = ({
  doctorsList,
  onSelectDoctorClick,
  showDoctorAptCount = false,
  selectedDoctorId, //for receipts customisation
}: {
  doctorsList: BasicDoctorInfo[];
  onSelectDoctorClick: (doctor: BasicDoctorInfo | undefined) => void;
  showDoctorAptCount?: boolean;
  selectedDoctorId?: string;
}) => {
  const [openDoctorSearch, setOpenDoctorSearch] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");

  //   const selectedDoctor = useFrontDeskStore((state) => state.selectedDoctor);
  // Use prop if provided, otherwise use queue store
  const storeSelectedDoctor = useQueueStore((state) => state.selectedDoctor);
  const selectedDoctor = selectedDoctorId
    ? doctorsList?.find((doc) => doc.oid === selectedDoctorId)
    : storeSelectedDoctor;

  const { data: queueConfigData } = useGetQueueConfig();
  const { workflow_views } = queueConfigData?.data || {};
  const { data: queueData } = useAllQueuesQuery();

  const queueApts = useMemo(() => {
    const apts: Set<Appointment> = new Set();
    const viewsToAggregate =
      workflow_views
        ?.filter((view) => view.includeInAgg)
        ?.map((view) => view.viewId) || [];

    viewsToAggregate.forEach((view) => {
      if (view) {
        const viewApts = queueData?.[view] || [];
        viewApts.forEach((apt) => {
          apts.add(apt);
        });
      }
    });

    return Array.from(apts);
  }, [queueData, workflow_views]);

  const searchDoctorFilterList =
    useFuseSearch(inputValue, doctorsList || [], ["name", "username"]) || [];
  const doctorStrips = useMemo(
    () =>
      doctorsList?.map((doctor) => (
        <DoctorFilterStripUi
          key={doctor.oid}
          doctorName={doctor.name}
          doctorPic={doctor.pic}
          aptCount={
            queueApts?.filter((apt) => apt.doctor_oid === doctor.oid).length ||
            0
          }
          doctorStatusList={[]}
          isSelected={selectedDoctor?.oid === doctor.oid}
          onClick={() => onSelectDoctorClick(doctor)}
          showAptCount={
            (!selectedDoctorId && selectedDoctor?.oid === doctor.oid) ||
            showDoctorAptCount
          }
        />
      )),
    [
      doctorsList,
      queueApts,
      selectedDoctor?.oid,
      showDoctorAptCount,
      onSelectDoctorClick,
    ]
  );
  return (
    <>
      {doctorStrips}
      {(doctorStrips || [])?.length > 3 ? (
        <div className="dr-sticky dr-right-0 dr-top-0 dr-bg-darwin-neutral-0">
          <Popover
            style={{ borderRadius: "1rem" }}
            placement="bottomRight"
            trigger={["click"]}
            destroyTooltipOnHide
            open={openDoctorSearch}
            onOpenChange={(value) => setOpenDoctorSearch(value)}
            content={
              <DoctorSearch
                list={searchDoctorFilterList}
                inputValue={inputValue}
                setInputValue={setInputValue}
                setSelectedDoctor={onSelectDoctorClick}
                selectedDoctor={selectedDoctor}
              />
            }
            overlayClassName="fd-popup"
          >
            <div>
              <TooltipComponent
                arrowPointAtCenter={true}
                placement="top"
                title={"Doctors List"}
              >
                <div className="dr-p-6 dr-cursor-pointer dr-rounded-8 dr-border-1 dr-border-darwin-neutral-200 hover:dr-border-darwin-primary-primary hover:dr-bg-darwin-primary-bg-light dr-bg-darwin-neutral-0">
                  <BarsRegularIcon className="dr-p-2 dr-w-24 dr-h-24 dr-text-darwin-neutral-600" />
                </div>
              </TooltipComponent>
            </div>
          </Popover>
        </div>
      ) : null}
    </>
  );
};
export default DoctorsList;
